import type { HubSignInErrorCode } from 'services/hub-auth-service.types';
import { clearLocalSession } from './clearLocalSession';
import { sessionMonitor } from './sessionMonitor';

export type SessionEndedReason = 'expired' | 'other-tab';

/** `location.state` of the sign-in page after a session ended. */
export interface LoginLocationState {
  sessionEnded?: SessionEndedReason;
  /** Why a sign-in through the Hub failed. */
  hubSignInError?: HubSignInErrorCode;
}

/**
 * Sign out a session the monitor judged dead, and say where to go next.
 *
 * Only removes the token that died, so a newer sign-in (from another tab) is
 * kept, and resets the monitor so the next session starts clean.
 */
export const endSession = (): { pathname: string; state: LoginLocationState } => {
  const deathInfo = sessionMonitor.getDeathInfo();

  clearLocalSession({ onlyToken: deathInfo?.token });

  return {
    pathname: '/login',
    state: {
      sessionEnded: deathInfo?.reason === 'logged-out-in-another-tab' ? 'other-tab' : 'expired',
    },
  };
};
